module.exports = "/_next/static/images/umbrella-duotone-9594913e6f6bea1a16c3fbe3b8c361bf.svg";